import Vue from 'vue'
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import en from 'iview/dist/locale/en-US';
Vue.locale('en-US',Object.assign(en))
Vue.config.lang = 'en-US';



// WEBPACK FOOTER //
// ./src/language/index.js